var _circle, _circle2, _circle3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcCircleGroup = function SvgIcCircleGroup(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 391 391",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 195.5,
    cy: 195.5,
    r: 194.5,
    stroke: "url(#paint0_linear_23961_434114)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 195.5,
    cy: 195.5,
    r: 133.5,
    stroke: "url(#paint1_linear_23961_434114)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.32,
    cx: 195.5,
    cy: 195.5,
    r: 66.5,
    stroke: "url(#paint2_linear_23961_434114)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23961_434114",
    x1: -46.5,
    y1: 78.0002,
    x2: 442.892,
    y2: 169.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#CAE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#26C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#86C9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF8AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#FFD2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23961_434114",
    x1: 24,
    y1: 111,
    x2: 361.317,
    y2: 181.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#CAE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#26C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#86C9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF8AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#FFD2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23961_434114",
    x1: 109,
    y1: 150.5,
    x2: 284.031,
    y2: 188.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#CAE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#26C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#86C9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#FF8AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911458,
    stopColor: "#FFD2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCircleGroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-circle-group.94220486.svg";
export { ForwardRef as ReactComponent };